<template>

  <!-- Gallery Video Slide -->
  <q-carousel-slide
    :name="name"
    v-if="slide"
    class="gallery-video-slide"
    :class="{cover: slide.cover}">

    <vue-plyr
      class="absolute-full">

      <video
        :src="getFileUrl(slide)"
        :style="{backgroundColor: color}"/>

    </vue-plyr>

    <gallery-slide-overlay
      top
      :slide="slide"/>

  </q-carousel-slide>

</template>

<script>

  import GallerySlideOverlay from '@src/components/gallery/gallery-slide-overlay';

  export default {
    name: 'gallery-video-slide',
    components: {
      GallerySlideOverlay,
    },
    props: {
      name: {
        type: String,
        default: '',
      },
      slide: {
        type: Object,
        default: null,
      },
      color: {
        type: String,
        default: undefined,
      },
    },
  };

</script>

<style lang="scss">

  .gallery-video-slide {
    pointer-events: auto;

    video,
    .plyr,
    .plyr__video-wrapper {
      width: 100% !important;
      height: 100% !important;
    }

    &.cover video {
      object-fit: cover;
    }
  }

</style>
